const focusable = [
	'a[href]:not([inert])',
	'area[href]:not([inert])',
	'input:not([disabled]):not([inert])',
	'select:not([disabled]):not([inert])',
	'textarea:not([disabled]):not([inert])',
	'button:not([disabled]):not([inert])',
	'iframe:not([inert])',
	'[contenteditable]:not([inert])',
	'[tabindex]:not([inert])'
];

function getFocusableChildren(parent) {
	let children = parent.querySelectorAll(focusable.join(','));
	if (children.length) {
		children = [...children].filter((child) => {
			return Boolean(
				child.tabIndex >= 0
			);
		});
	}

	return children;
}

function setTabIndex(elems, index) {
	const items = elems && elems.length ? [...elems] : [];
	for (let item of items) {
		item.tabIndex = index;
	}
}

export { getFocusableChildren, setTabIndex };
